export class PaypalLinkPaymentModal{
    constructor(
        private saId:string,
        private isPaid:boolean,
        private paypalPaymentId:string,
        private invoiceHtmlContent:string,
        private MasterPaypalModel,
        private isReoccured:boolean){

    }
}